<template>
  <div class="com-header-wrap">
    <div class="block-left">
      <img :src="getPath('comHeaderLogo')" @click="goWapHomePage" />
    </div>
    <div v-if="title" class="header-title">{{ title }}</div>
    <!-- 首页类型； -->
    <div v-if="type === '1'" class="block-right">
      <div class="download-icon" @click="goDownload">下载APP</div>
      <div v-if="!hasLogin" class="login-btn" @click="handleLoginClick">
        登录
      </div>
      <img v-else class="avatar" :src="avatar" />
    </div>
    <div v-else class="block-right">
      <img
        v-if="type === '3'"
        :src="getPath('homePageIconSearch')"
        class="search-icon"
        @click="handleSearchClick"
      />
      <!-- 带搜索icon和下拉菜单 -->
      <div
        v-if="type === '4'"
        class="search-content"
        @click="handleSearchClick"
      >
        <img :src="getPath('homePageIconSearch')" />
        搜索
      </div>
      <!-- 带搜索框和下拉菜单 -->
      <img
        :src="
          showDropMenus
            ? getPath('comHeaderDropMenuIconExpend')
            : getPath('comHeaderDropMenuIconClose')
        "
        class="drop-menu-icon"
        @click="handleDropClick"
      />
    </div>

    <div v-if="showDropMenus" class="drop-menu">
      <div
        v-for="(item, index) in dropMenus"
        :key="index"
        class="menu-item"
        :class="{ active: item.value === dropMenuActive }"
        @click="dropMenuClick(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <div
      v-if="showDropMenus"
      class="drop-menu-mask"
      @click="handleMaskClick"
    ></div>
  </div>
</template>

<script lang="js">
import Vue from 'vue';
import { getPath } from '@/utils/getOssFilePath';
import { getCookie } from '@/utils/cookie';
import { disableBodyScroll, enableBodyScroll } from '@/utils/dom';
import { goDownload, goWapHomePage, goSearch } from '@/utils/jumpLink';

import { stockDomain, gwDomain } from '@/utils/jumpLink/domain';

export default Vue.extend({
    props: {
        type: {
            type: String, // '1': 首页类型； '2': 只有下拉菜单; '3': 带搜索icon和下拉菜单; '4': 带搜索框和下拉菜单
            default: () => '1',
        },
        title: {
            type: String,
            default: () => '',
        },
        dropMenuActive: {
            type: Number,
            default: () => undefined,
        },
    },
    data() {
        return {
            hasLogin: false,
            userInfo: {},
            avatar: getPath('comHeaderDefaultAvatar'),
            showDropMenus: false,
            dropMenus: [
                {
                    value: 0,
                    label: '资讯',
                },
                {
                    value: 1,
                    label: '股票',
                },
                {
                    value: 2,
                    label: '基金',
                },
                {
                    value: 3,
                    label: '板块',
                },
                {
                    value: 4,
                    label: '全球',
                },
            ],
        };
    },
    mounted() {
        const userInfo =
            (getCookie('userInfo') && JSON.parse(getCookie('userInfo'))) ||
            null;
        if (userInfo && userInfo.token) {
            this.hasLogin = true;
            this.userInfo = userInfo;
            userInfo.headImage && (this.avatar = userInfo.headImage);
        }
    },
    methods: {
        getPath,
        goDownload,
        goWapHomePage,
        handleDropClick() {
            this.showDropMenus = !this.showDropMenus;
            if (this.showDropMenus) {
                disableBodyScroll();
            } else {
                enableBodyScroll();
            }
        },
        handleMaskClick() {
            this.showDropMenus = false;
            enableBodyScroll();
        },
        dropMenuClick(data) {
            if(data.value === this.dropMenuActive) return
            if (data.value === 0) {
                window.open(`${gwDomain}/infoList.html`, '_self')
            } else if (data.value === 1) {
                window.open(`${gwDomain}/indexQuote.html`, '_self')
            } else if (data.value === 2) {
                window.open(`${gwDomain}/fundRank.html`, '_self')
            } else if (data.value === 3) {
                window.open(`${stockDomain}/wap/bkRank.html?tab=0`, '_self');
            } else if (data.value === 4) {
                window.open(`${gwDomain}/qqindex.html`, '_self')
            }
        },
        handleLoginClick() {
            this.$router.push({
                path: '/login.html',
            });
        },
        handleSearchClick() {
            goSearch()
        },
    },
});
</script>

<style lang="stylus" scoped>
.com-header-wrap {
    width: 100%;
    height: 56px;
    box-sizing: border-box;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    background: #252733;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.02);
    color: #fff;

    .block-left {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        line-height: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;

        img {
            width: 107px;
            height: 28px;
        }
    }

    .header-title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .block-right {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .download-icon {
            font-size: 14px;
            line-height: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #E94041;
            padding: 5px 12px;
            border-radius: 13px;
            border: 1px solid #E94041;
            margin-right: 24px;
        }
        .login-btn {
            font-size: 16px;
            line-height: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #FFFFFF;
        }
        .avatar {
            height: 30px;
            width: 30px;
            border-radius: 50%;
        }
        .search-icon {
            width: 20px;
            height: 20px;
            margin-right: 16px;
        }
    }
}

.search-content {
    width: 74px;
    height: 26px;
    background: #353648;
    border-radius: 13px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #BBBBBB;
    line-height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;

    img {
        width: 16px;
        height: 16px;
        margin-right: 14px;
    }
}

.drop-menu-icon {
    width: 20px;
    height: 20px;
}

.drop-menu-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: -1;
}

.drop-menu {
    position: absolute;
    left: 4px;
    bottom: -53px;
    width: 367px;
    height: 53px;
    background: #FFFFFF;
    border-radius: 4px;
    z-index: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .menu-item {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .active {
        font-weight: 500;
        color: #333333;
        position: relative;

        &:after {
            content: "";
            width: 16px;
            height: 4px;
            border: none;
            border-radius: 3px;
            background: #B60014;
            position: absolute;
            left: 10px;
            bottom: -6px;
        }
    }
}

.drop-menu:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 8px solid white;
    position: absolute;
    right: 15px;
    top: -8px;
}
</style>
